/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationWarrantiesGroupProtectionMutation from '../graphql/mutations/SaveSimulationWarrantiesGroupProtectionMutation.js';

export const useSaveSimulationWarrantiesGroupProtectionMutation = () => {
  return useCommitMutation(SaveSimulationWarrantiesGroupProtectionMutation, { dataProp: 'saveSimulationWarrantiesGroupProtection_M_simulation_warranties_group_protection' });
};

export default useSaveSimulationWarrantiesGroupProtectionMutation;
